export default "__VITE_ASSET__DYVxyoFR__"